import EditModal from "./EditModal";
import FormulaModal from "./FormulaModal";
import Functions7FormulaModal from "./Functions7FormulaModal";
import ViewInfoModal from "./ViewInfoModal";
//import VideoModal from "./VideoModal";
import UserFieldModal from "./UserFieldModal";
import UserModal from "./UserModal";
import CompanyModal from "./CompanyModal";
import PermissionModal from "./PermissionModal";
import PowerPermission from "./PowerPermission";
import FloorPlanModal from "./FloorPlanModal";
import BaseStationModal from "./BaseStationModal";
import PersonnelModal from "./PersonnelModal";
import MqttModal from "./MqttModal";
import LiveDashboardModal from "./LiveDashboardModal";
import HistoryWorkspaceModal from "./HistoryWorkspaceModal";
import AlertConfigModal from "./AlertConfigModal";
import EquipmentModal from "./EquipmentModal";
import "./modal.css";
export {
  EditModal,
  FormulaModal,
  Functions7FormulaModal,
  ViewInfoModal,
  //VideoModal,
  UserFieldModal,
  UserModal,
  CompanyModal,
  PermissionModal,
  PowerPermission,
  FloorPlanModal,
  BaseStationModal,
  PersonnelModal,
  MqttModal,
  LiveDashboardModal,
  HistoryWorkspaceModal,
  AlertConfigModal,
  EquipmentModal,
};
